import clsx from 'clsx';
import styles from './Text.module.scss';
import { type ReactNode } from 'react';

type TextColor =
  | 'primary'
  | 'secondary'
  | 'error'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info';

interface Props {
  children: ReactNode;
  color?: TextColor;
  monospace?: boolean;
}

export function Text({
  children,
  color = 'primary',
  monospace: monospaced,
}: Props) {
  return (
    <span
      className={clsx(
        styles['text'],
        styles[`text-color-${color}`],
        monospaced && styles['text-monospaced'],
      )}
    >
      {children}
    </span>
  );
}
